//#region IMPORT
/** Components Import */
import { Button } from '../../../../Components/MUIs';
/** AG-grid Import */
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { BusinessCommon } from '../../../../Components/BusinessCommon';
import { GridFileUploadF } from '../../../../Components/Ui/GridFileUpload/GridFileUploadF';
import { getColumnDefs1 } from './SAM_BASIC_01_ColumnDefs';
import GridFunctions from '../../../../Services/agGrid/ag-Grid-functions';
/** Icons Import */
//#endregion

function SAM_BASIC_01(props) {
  //#region 변수
  const columnDefs1 = getColumnDefs1(props);
  //#endregion

  return (
    <BusinessCommon
      title1={'작업계획서 기본정보'}
      title2={'작업계획서 미리보기'}
      gridId={props.gridId1}
      getRowId={(params) => {
        return params.data.no;
      }}
      addClick1={() => {
        if (!props.validateSelection()) return;

        GridFileUploadF('', props.gridRef1, props, {
          blockVideo: true,
        });
      }}
      refreshClick1={() => {
        if (!props.validateSelection()) return;

        props.SearchLogic1();
      }}
      deleteClick1={(e) => {
        if (!props.validateSelection()) return;

        const newRowExists = props.selectedRowData1.some(
          (row) => row.newYn === 'Y'
        );

        if (!newRowExists) {
          props.MarkedForDeletion1(props.selectedRowData1);
        } else {
          props.NewYnErrorMsg();
        }
      }}
      gridRef={props.gridRef1}
      columnDefs={columnDefs1}
      rowData={props.rowData1}
      setSelectedRowData={props.setSelectedRowData1}
      setChangedRowData={props.setChangedRowData1}
      rowSelection={'multiple'}
      onCellClicked={(e) => {
        const gridApi = props.gridRef1.current.api;
        const clickedRowIndex = e.rowIndex;

        const isCheckboxClick = e.event?.target?.type === 'checkbox';

        if (!isCheckboxClick) {
          gridApi.ensureIndexVisible(clickedRowIndex, 'middle');
          gridApi.setFocusedCell(clickedRowIndex, 'coNm');

          const copied = JSON.parse(JSON.stringify(e.data));
          props.handleRowSelection1(copied, clickedRowIndex);

          gridApi
            .getDisplayedRowAtIndex(clickedRowIndex)
            ?.setSelected(true, false);
        }
      }}
      onSelectionChanged={() => {
        const gridApi = props.gridRef1?.current?.api;
        const selectedNodes = gridApi.getSelectedNodes();
        const selectedData = selectedNodes.map((n) => n.data);
        props.selectedRowNosRef1.current = new Set(
          selectedData.map((r) => r.no)
        );
        props.setSelectedRowData1(selectedData);
      }}
      onCellValueChanged={(e) => {
        GridFunctions.onCellValueChanged(
          e,
          props.gridRef1,
          props.setChangedRowData1
        );
      }}
      viewMode="preview"
      selectedRowData={props.selectedRowData1}
      fileNameField="saveName"
      filePathField="filePath"
      other1={
        <>
          {/* <Button
            name="서식 다운로드"
            onClick={() => {
              if (!props.validateSelection()) return;

              props.DownloadLogic1();
            }}
          /> */}
          {/* 멀티 다운로드 훅으로 빼야함 */}
          <Button
            name="멀티 다운로드"
            onClick={() => {
              if (!props.validateSelection()) return;

              if (props.selectedRowData1?.length === 0) {
                props.dispatch(
                  props.showSnackbar({
                    message: '다운로드할 항목을 먼저 선택해 주세요.',
                    type: 'warning',
                  })
                );

                return;
              }

              props.selectedRowData1.forEach((item, index) => {
                setTimeout(() => {
                  props.DownloadLogic2(item);
                }, index * 300);
              });
            }}
          />
        </>
      }
    />
  );
}

export default SAM_BASIC_01;
